import React from "react";
import PropTypes from "prop-types";

import Breadcrumbs from "./Breadcrumbs";

const PageHeader = ({ actions, breadcrumbs, description, meta, title }) => (
  <header className="wsm-page-header">
    {breadcrumbs?.length > 0 && <Breadcrumbs items={breadcrumbs} />}
    <div className="wsm-page-header__row">
      <div className="wsm-page-header__content">
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        {meta && <div className="wsm-page-header__meta">{meta}</div>}
      </div>
      {actions && <div className="wsm-page-header__actions">{actions}</div>}
    </div>
  </header>
);

PageHeader.propTypes = {
  actions: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    label: PropTypes.string.isRequired,
  })),
  description: PropTypes.node,
  meta: PropTypes.node,
  title: PropTypes.node.isRequired,
};

export default PageHeader;
